import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppUser } from '../helpers/interfaces';

interface LoggedOnUserState {
    value: AppUser | null
}

export const loggedOnUser = createSlice({
    name: 'loggedOnUser',
    initialState: {
        value: null,
    } as LoggedOnUserState,
    reducers: {
        setLoggedOnUser: (state, action: PayloadAction<AppUser | null>) => {
            state.value = action.payload
        },
    },
})

export const { setLoggedOnUser } = loggedOnUser.actions;
export default loggedOnUser.reducer;